var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.01,
    height: 42,
    viewBox: "0 0 42.01 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M21,12.469A10.768,10.768,0,1,0,31.773,23.238,10.751,10.751,0,0,0,21,12.469Zm0,17.769a7,7,0,1,1,7-7A7.014,7.014,0,0,1,21,30.239Zm13.72-18.21a2.512,2.512,0,1,1-2.512-2.512A2.506,2.506,0,0,1,34.725,12.029Zm7.132,2.549c-.159-3.365-.928-6.345-3.393-8.8s-5.436-3.224-8.8-3.393c-3.468-.2-13.861-.2-17.329,0C8.98,2.545,6,3.313,3.535,5.769S.311,11.2.142,14.569c-.2,3.468-.2,13.861,0,17.329.159,3.365.928,6.345,3.393,8.8s5.436,3.224,8.8,3.393c3.468.2,13.861.2,17.329,0,3.365-.159,6.345-.928,8.8-3.393s3.224-5.436,3.393-8.8c.2-3.468.2-13.852,0-17.319Zm-4.48,21.04a7.088,7.088,0,0,1-3.992,3.992c-2.765,1.1-9.325.843-12.38.843s-9.625.244-12.38-.843a7.088,7.088,0,0,1-3.992-3.992c-1.1-2.765-.843-9.325-.843-12.38s-.244-9.625.843-12.38A7.088,7.088,0,0,1,8.624,6.865c2.765-1.1,9.325-.843,12.38-.843s9.625-.244,12.38.843a7.088,7.088,0,0,1,3.992,3.992c1.1,2.765.843,9.325.843,12.38S38.473,32.863,37.377,35.618Z",
    transform: "translate(0.005 -2.238)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.62c17c1d74910722f4e64e0c0e8add33.svg";
export { ForwardRef as ReactComponent };